import { useParams } from '@tanstack/react-router'

import { Tabs, TabsList, TabsTriggerAsLink } from '@/components/tabs'

interface Props {
    active: 'text' | 'colours' | 'components' | 'forms' | 'icons'
}

export default function PlaygroundNavigation({ active }: Props) {
    const params = useParams({ strict: false }) as any
    return (
        <Tabs>
            <TabsList>
                <TabsTriggerAsLink to="/$client_code/playground" params={params} active={active === 'text'}>
                    Text
                </TabsTriggerAsLink>
                <TabsTriggerAsLink to="/$client_code/playground/colours" params={params} active={active === 'colours'}>
                    Colours
                </TabsTriggerAsLink>
                <TabsTriggerAsLink
                    to="/$client_code/playground/components"
                    params={params}
                    active={active === 'components'}
                >
                    Components
                </TabsTriggerAsLink>
                <TabsTriggerAsLink to="/$client_code/playground/forms" params={params} active={active === 'forms'}>
                    Forms
                </TabsTriggerAsLink>
                <TabsTriggerAsLink to="/$client_code/playground/icons" params={params} active={active === 'icons'}>
                    Icons
                </TabsTriggerAsLink>
            </TabsList>
        </Tabs>
    )
}
